import { getCurrentUser, login as pollworkerLogin } from 'pollworker/src/fetchers';
import { useAppDispatch } from 'pollworker/src/hooks';
import { setCurrentCustomer, setCurrentPollworkerUser } from 'pollworker/src/state/actions';
import { getWebsiteUserFromLocalStorage } from 'pollworker/src/utils/localStorage';
import React, { useState } from 'react';
import { Login } from 'shared/src/components';
import * as Sentry from 'shared/src/setupSentry';
import { useLocation } from 'wouter';

function clearStoredSession() {
  window.localStorage.removeItem('ZumoToken');
  window.localStorage.removeItem('CurrentUser');
}

export default function PollworkerLogin() {
  const [loginError, setLoginError] = useState<string | undefined>(undefined);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [, navigate] = useLocation();
  const dispatch = useAppDispatch();

  const websiteUser = getWebsiteUserFromLocalStorage();

  const logoUrl = websiteUser ? `${import.meta.env.VITE_DOMAIN}/images/${websiteUser.CustomerId}/logo` : undefined;

  return (
    <div className="mb-10">
      <Login
        logo={logoUrl}
        errorMessage={loginError}
        onForgotPassword={() => navigate('~/login/forgot')}
        login={(username, password) => {
          setLoginError(undefined);

          if (isLoggingIn) {
            return;
          }

          setIsLoggingIn(true);

          pollworkerLogin(username, password)
            .then(async ([success, data]) => {
              if (!success || !data?.AuthenticatedUser) {
                clearStoredSession();
                setLoginError(data?.LoginMessage ?? data?.loginMessage ?? 'Something went wrong while signing in. Please try again.');
                return [success, data];
              }

              window.localStorage.setItem('ZumoToken', data.AuthenticatedUser.ZumoToken);
              window.localStorage.setItem('CurrentUser', data.AuthenticatedUser.UserId);

              const resp = await getCurrentUser(data.AuthenticatedUser.UserId);

              if (!resp || !resp?.EVUserId || !resp.Customer) {
                clearStoredSession();
                setLoginError('We could not verify your account for this site. Please try again.');
                return [success, data];
              }

              Sentry.identifyLoggedInUser(resp.EVUserId, resp.UserId, '', resp.Customer.Id, resp.Customer.Name, resp.Customer.State);
              dispatch(setCurrentCustomer(resp));
              dispatch(setCurrentPollworkerUser(resp));
              navigate('~/news');

              return [success, data];
            })
            .catch(() => {
              clearStoredSession();
              setLoginError('Something went wrong while signing in. Please try again.');
            })
            .finally(() => setIsLoggingIn(false));
        }}
        isLoggingIn={isLoggingIn}
      />
    </div>
  );
}
